import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const createHashtag = async (payload: FormData) => {
	const response = await cmsClient.post<IAdminHashtag>(
		"/homepage/admin/hashtags/",
		payload
	);

	return response.data;
};

const useCreateAdminHashtag = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(
			<CustomToast type="Success" message="Hashtag created successfully" />,
			{ hideProgressBar: true }
		);

		queryClient.invalidateQueries(["admin-hashtags"]);
		queryClient.invalidateQueries(["favourite-feeds"]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(createHashtag, {
		onError,
		onSuccess
	});

	return mutation;
};

export default useCreateAdminHashtag;
